module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAQCAYAAADj5tSrAAAAAXNSR0IArs4c6QAAAR9JREFUOBHllLFKw1AUhu9/cokdVNBBpWQxTYgPoHPJqnOGLu0r6OySzU3wJXyDzpnFQKYMhVCXCmrRUnBR7DneBMwL9Dr1TocL9/vvf869P9I0pcFweEqCCyg6VJaWKH5lyDjy/UedJInW4sSi5BJQu5Y0FARLMD7zPC9QQ6uqOlgRRbTCvi0RIn5n5kkYhnNbzA3hNDMxXpFlT1ue9+Pa8j2b6e84Pv4yPDHwTHuePwA1r6trS0QEz8Lqrige7qmFQv25arfWK6TlNUX9Ifv9kftf7Vrvsht3uplJHSvMdAJgz1YH2JEPx8RKEARvKMvS7XS2r0xAXhuRHVsiSmRpvt/NYjG/rZ1gMp2emag/N1F/ZEvERP0LKx5HvV7+C1sUZl6pOCAJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/listMenu.png
// module id = 825
// module chunks = 1